
<template>
 <div>
     <ValidationObserver ref="formModalValidate">
         <ValidationProvider name="period_id" rules="required" v-slot="{valid, errors}">
             <b-form-group :label="$t('period')">
                <PaymentPeriodsSelectbox :semesters="[1,2]" v-model="period_id" :validate-error="errors[0]"/>
             </b-form-group>
         </ValidationProvider>
     </ValidationObserver>
     <processing-button :processing="loading" label="download" :disabled="loading" @click="save">
     </processing-button>

 </div>
</template>
<script>
import PaymentPeriodsSelectbox from "@/components/interactive-fields/PaymentPeriodsSelectbox";
import PaymentPlanService from "@/services/PaymentPlanService";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import qs from "qs";

export default {
    name: "PaymentConfirmationDocument",
    props:{
        studentProgramId:{
            default: null
        }
    },
    components:{
        ProcessingButton,
        PaymentPeriodsSelectbox
    },
    data(){
        return {
            period_id:null,
            response_type:'pdf',
            loading:false,
            responseTypeOptions: [
                {value: 'page', text: this.$t('page')},
                // {value: 'excel', text: this.$t('excel')},
                {value: 'pdf', text: 'PDF'},
            ],
        }
    },
    methods:{
       async save(){
          const isValid= await this.$refs.formModalValidate.validate();
          if (!isValid)return
           try {
               this.loading=true
               const config={
                   params:{
                       student_program_id:this.studentProgramId,
                       period_id:this.period_id,
                       response_type:this.response_type,

                   },
                   paramsSerializer: (params) => qs.stringify(params, { encode: false })
               }
               if (this.response_type !== 'page') {
                   config.responseType = 'arraybuffer';
               }
               const res =await  PaymentPlanService.reportsPaymentConfirmation(config)
               this.callback(res)
           }catch (error) {
              this.showErrors(error,this.$refs.formModalValidate)
           }finally
           {
               this.loading=false
           }
       },
        callback(response) {
            if (this.response_type === 'page') {
                this._openFile(response);
            }
            else if (this.response_type === 'excel') {
                this._downloadFile(response, this.$t('payment_confirmation_document') + '.xlsx');
            }
            else if (this.response_type === 'pdf') {
                this._downloadFile(response, this.$t('payment_confirmation_document') + '.pdf');
            }
        }
    }
}
</script>


<style scoped>

</style>
